/* eslint-disable no-use-before-define */
import Yup from '../../i18n/yup'

export const baseUrl = `${process.env.REACT_APP_API_URL}/portal`

export const validationSchema = Yup.object().shape({
  manualLogin: Yup.boolean(),
  facebookLogin: Yup.boolean().test('facebookLogin', 'PORTAL.ERROR_LOGIN',function () {
    return !(this.parent.facebookLogin === false && this.parent.manualLogin === false)
  }),
  autoLogin: Yup.boolean(),
  email: Yup.boolean()
  .when('manualLogin', (manualLogin, schema) => {
    return manualLogin ? schema.test('email', 'PORTAL.EMAIL_IS_REQUIRED', (v) => v === true) : schema
  }),
  gender: Yup.boolean()
    .when('manualLogin', (manualLogin, schema) => {
      return manualLogin ? schema.test('gender', 'PORTAL.GENDER_IS_REQUIRED', (v) => v === true) : schema
    }),
  birthdate: Yup.boolean()
  .when('manualLogin', (manualLogin, schema) => {
    return manualLogin ? schema.test('birthdate', 'PORTAL.BIRTHDATE_IS_REQUIRED', (v) => v === true) : schema
  }),
  logo: Yup.object().shape({
    portalLogo: Yup.string().required(),
    logoUrlNew: Yup.string().required(),
    logoUrl: Yup.string().required(),
  }).nullable().required(),
  background: Yup.object().shape({
    portrait: Yup.object().shape({
      low: Yup.string().required(),
      mid: Yup.string().required(),
      high: Yup.string().required(),
    }),
    landscape: Yup.object().shape({
      low: Yup.string().required(),
      mid: Yup.string().required(),
      high: Yup.string().required(),
    }),
  }).nullable().required(),
})

export const formSwitchesData = [
  {
    id: 'facebookLogin',
    title: 'PORTAL.FACEBOOK_LOGIN',
    type: 'switch',
  },
  {
    id: 'manualLogin',
    title: 'PORTAL.MANUAL_LOGIN',
    type: 'switch',
  },
];

export const formImagesData = [
  {
    id: 'logo',
    title: 'PORTAL.LOGO_TITLE',
    type: 'image',
    uploadUrl: `${baseUrl}/upload-logo`,
    getImagePath: (value) => value?.portalLogo ? `images/logos/${value.portalLogo}` : null,
  },
  {
    id: 'background',
    title: 'PORTAL.BACKGROUND_TITLE',
    type: 'image',
    uploadUrl: `${baseUrl}/upload-background`,
    getImagePath: (value) => value?.landscape?.mid ? `images/${value.landscape?.mid}` : null,
  },
];

export const formOptionsData = [
  {
    id: 'email',
    title: 'PORTAL.OPTION_FIELDS.EMAIL',
    type: 'checkbox',
  },
  {
    id: 'name',
    title: 'PORTAL.OPTION_FIELDS.NAME',
    type: 'checkbox',
  },
  {
    id: 'lastname',
    title: 'PORTAL.OPTION_FIELDS.LASTNAME',
    type: 'checkbox',
  },
  {
    id: 'gender',
    title: 'PORTAL.OPTION_FIELDS.GENDER',
    type: 'checkbox',
  },
  {
    id: 'birthdate',
    title: 'PORTAL.OPTION_FIELDS.BIRTHDATE',
    type: 'checkbox',
  },
  {
    id: 'phone',
    title: 'PORTAL.OPTION_FIELDS.PHONE',
    type: 'checkbox',
  },
];

export const initialValues = {
  manualLogin: false,
  facebookLogin: false,
  autoLogin: false,
  logo: null,
  background: null,
  email: true,
  name: false,
  lastname: false,
  gender: false,
  birthdate: false,
  phone: false,
}

export const transformServerData = data => ({
  manualLogin: data.manualLogin,
  facebookLogin: data.facebookLogin,
  email: data.registerFields.regular.includes('email'),
  name: data.registerFields.regular.includes('name'),
  lastname: data.registerFields.regular.includes('lastname'),
  gender: data.registerFields.regular.includes('gender'),
  birthdate: data.registerFields.regular.includes('birthdate'),
  phone: data.registerFields.regular.includes('phone'),
  logo: {
    portalLogo: data.portalLogo,
    logoUrlNew: data.logoUrlNew,
    logoUrl: data.logoUrl,
  },
  background: data.portalBackgroundImage
})

export const generateRegularArray = props =>
  Object.keys(props).filter(key => formOptionsData.map(opt => opt.id).includes(key) && props[key])

export const transformDataToSendToServer = values => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      manualLogin: values.manualLogin,
      facebookLogin: values.facebookLogin,
      autoLogin: false,
      registerFields: {
        regular: generateRegularArray(values),
      },
      portalLogo: values.logo.portalLogo,
      logoUrlNew: values.logo.logoUrlNew,
      logoUrl: values.logo.logoUrl,
      portalBackgroundImage: values.background,
    }),
  }
}
